import { styled } from "@mui/material";
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from "@mui/x-data-grid-premium";

const StyledWrapper = styled("div")(({ theme }) => ({
  opacity: 0,
  transition: "opacity 0.3s ease",
  ".MuiDataGrid-row:hover &": {
    opacity: 1,
  },
}));

export const HoverAction = (props: GridActionsCellItemProps) => (
  <StyledWrapper>
    <GridActionsCellItem {...props} ref={undefined} />
  </StyledWrapper>
);

HoverAction.displayName = "HoverAction";
